import { PageLocatorMap } from '../types/PageLocatorMap';

export const signUpPage = {
  alert: {
    error: 'signup.alert.error',
  },
  footer: {
    root: 'signup.footer',
  },
  form: {
    emailInput: 'signup.form.email-input',
    emailInputError: 'signup.form.email-error',
    firstNameInput: 'signup.form.first-name-input',
    firstNameInputError: 'signup.form.first-name-error',
    h1: 'signup.form.heading1',
    h2: 'signup.form.heading2',
    lastNameInput: 'signup.form.last-name-input',
    lastNameInputError: 'signup.form.last-name-error',
    phoneInput: 'signup.form.phone-input',
    phoneInputError: 'signup.form.phone-error',
    privacyLink: 'signup.form.privacy-link',
    root: 'signup.form.root',
    submitButton: 'signup.form.submit-button',
    termsLink: 'signup.form.terms-link',
  },
  header: {
    root: 'signup.header',
    signInLink: 'signup.header.signin-link',
  },
} as const satisfies PageLocatorMap;
